import React from 'react';
import ServicesPage from '../components/services';

export default function Services() {
    return (
        <div>
            <ServicesPage />
        </div>
    )
}